import Vue from "vue";
import Vuex from "@store/store";
import {
    baseUrl,
    isSignedIn,
    getHeaders,
    getMultipartHeaders,
} from "@services/AuthServices";
import { queryFilter } from "@src/filters/query-filter";

Vue.use(Vuex);

export async function RequestManagerServicesGetRequests(filters) {
    await isSignedIn();

    let query = "";
    if (filters) {
        query = queryFilter(filters);
    }
    const urlApi = `${baseUrl}/RequestManager${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function RequestManagerServicesCreateRequest(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/RequestManager`;

    return axios.post(urlApi, body, getHeaders());
}

export async function RequestManagerServicesGetRequest(ticketId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/RequestManager/${ticketId}`;

    return axios.get(urlApi, getHeaders());
}

export async function RequestManagerServicesUpdateRequest(ticketId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/RequestManager/${ticketId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function RequestManagerServicesAddPart(ticketId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/RequestManager/${ticketId}/part`;

    return axios.put(urlApi, body, getHeaders());
}

export async function RequestManagerServicesIsEntitySupplier(entityId) {
    await isSignedIn();

    let query = "";
    if (entityId) {
        query = queryFilter({ entityId });
    }

    const urlApi = `${baseUrl}/RequestManager/is-entity-supplier${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function RequestManagerServicesPrintRequest(ticketId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/RequestManager/${ticketId}/print/`;

    return axios.post(urlApi, body, { ...getHeaders(), responseType: "blob" });
}

export async function RequestManagerServicesGetConversation(conversationId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/RequestManager/conversation/${conversationId}`;

    return axios.get(urlApi, getHeaders());
}

export async function RequestManagerServicesPostMessage(
    conversationId,
    body,
    cb
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/RequestManager/conversation/${conversationId}`;

    return axios.post(urlApi, body, {
        headers: getMultipartHeaders().headers,
        onUploadProgress: cb,
    });
}

export async function RequestManagerServicesGetWhatsAppConversations(filters) {
    await isSignedIn();

    let query = "";
    if (filters) {
        query = queryFilter(filters);
    }
    const urlApi = `${baseUrl}/RequestManager/whatsapp/conversations${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function RequestManagerServicesGetWhatsAppConversation(
    conversationId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/RequestManager/whatsapp/conversation/${conversationId}`;

    return axios.get(urlApi, getHeaders());
}

export async function RequestManagerServicesGetTotalUnreadMessages() {
    await isSignedIn();

    const urlApi = `${baseUrl}/RequestManager/total-unread-messages`;

    return axios.get(urlApi, getHeaders());
}

export async function RequestManagerServicesGetInbox(filters) {
    await isSignedIn();

    let query = "";
    if (filters) {
        query = queryFilter(filters);
    }
    const urlApi = `${baseUrl}/RequestManager/inbox${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function RequestManagerServicesGetInboxEntityUsers(
    entityId,
    filters
) {
    await isSignedIn();

    let query = "";
    if (filters) {
        query = queryFilter(filters);
    }
    const urlApi = `${baseUrl}/RequestManager/inbox/entity/${entityId}/users${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function RequestManagerServicesGetInboxChat(
    entityId,
    userId,
    filters
) {
    await isSignedIn();

    let query = "";
    if (filters) {
        query = queryFilter(filters);
    }
    const urlApi = `${baseUrl}/RequestManager/inbox/entity/${entityId}/user/${userId}/chat${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function RequestManagerServicesSearchInboxChat(
    entityId,
    userId,
    filters
) {
    await isSignedIn();

    let query = "";
    if (filters) {
        query = queryFilter(filters);
    }
    const urlApi = `${baseUrl}/RequestManager/inbox/entity/${entityId}/user/${userId}/chat/search${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function RequestManagerServicesMarkRead(entityId, userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/RequestManager/inbox/entity/${entityId}/user/${userId}/chat/mark-read`;

    return axios.get(urlApi, getHeaders());
}

export async function RequestManagerServicesGetIAMEquivalence(ticketId, referenceOE) {
    await isSignedIn();

    const urlApi = `${baseUrl}/RequestManager/${ticketId}/reference/${referenceOE}/iam/equivalents`;

    return axios.get(urlApi, { ...getHeaders(), timeout: 15000 });
}

export async function RequestManagerServicesChangeOwner(ticketId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/RequestManager/${ticketId}/change-owner`;

    return axios.put(urlApi, body, getHeaders());
}

export async function RequestManagerServicesGetChangeOwnerDropdown(filters) {
    await isSignedIn();

    let query = "";
    if (filters) {
        query = queryFilter(filters);
    }
    const urlApi = `${baseUrl}/RequestManager/change-owner-dropdown${query}`;

    return axios.get(urlApi, getHeaders());
}
